import { createApp } from 'vue';
import Cookie from 'js-cookie';
import CookieConsentApp from './cookie-consent/CookieConsentApp.vue';

let appInstance = null;
let data = null;

export function getCookieConsentData() {
    if (!data) {
        const dataEl = document.getElementById('ccnt-data');
        if (!dataEl && !dataEl.innerText) {
            console.warn(`Failed to get cookie consent data`);
        } else {
            data = JSON.parse(dataEl.innerText || '{}');
        }
    }
    return data;
}

/**
 * Returns cookies consent app instance after it has been initialized
 *
 * @returns {object}
 */
export function getCookieConsentAppInstance() {
    return appInstance;
}

export default function initCookieConsent() {
    const rootEl = document.getElementById('ccnt-app');
    if (!rootEl) {
        console.warn(`Failed to initialize cookie notice: missing required DOM nodes`);
    }
    try {
        const props = getCookieConsentData();

                    
                                                 
                           
                                                               
                                                                            
                                                                    
                                                                                             
                           
                 

        const app = createApp(CookieConsentApp, props);
        appInstance = app.mount(rootEl);
    } catch (err) {
        console.warn(`Failed to initialize cookie notice due to an error`, err);
    }
}
